import { useState } from 'react';

import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { CompanySearchDto } from 'models/dtoTypes';
import CompanySearchWidget from '../companyList/CompanyListDetailPage/_companySearchWidget';
import { countryOptions } from 'utils/countries';

const PREFIX = 'ResolveMultipleResultModal';

const classes = {
  root: `${PREFIX}-root`,
  dialogContent: `${PREFIX}-dialogContent`,
  button: `${PREFIX}-button`,
  submitButton: `${PREFIX}-submitButton`,
  flashSpacer: `${PREFIX}-flashSpacer`,
  paper: `${PREFIX}-paper`
};

const StyledDialog = styled(Dialog)((
  {
    theme
  }
) => ({
  [`&.${classes.root}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  [`& .${classes.dialogContent}`]: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    minWidth: 500
  },

  [`& .${classes.submitButton}`]: {
    minWidth: 100,
    height: 50
  },

  [`& .${classes.flashSpacer}`]: {
    minHeight: 10,
  },

  [`& .${classes.paper}`]: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  '& .form-container > *': {
    marginBottom: 15,
  }

}));

export interface IField {
  required?: boolean;
  label: string;
  widget: string;
  name: string;
  description?: string;
  options?: { value: string; label: string; }[];
  placeholder?: string;
}

interface Props {
  open: boolean;
  label: string;
  onClose: () => void;
  onSelect: (company?: CompanySearchDto) => void;
}

function SearchCompanyDialog(props: Props): JSX.Element {
  const {
    label,
    open,
    onClose,
    onSelect,
  } = props;
  const [selectedCompany, setSelectedCompany] = useState<CompanySearchDto>();

  const handleClose = () => {
    // unset selected ids when close popup
    setSelectedCompany(undefined);
    onClose();
  };

  function handleFinishSelect() {
    onSelect(selectedCompany);
    // unset selected ids when close popup
    setSelectedCompany(undefined);
  }

  const handleToggleCompanyId = (_: string, company?: CompanySearchDto) => {
    setSelectedCompany(company);
  };

  const renderCardContent = () => {
    const formattedOptions = countryOptions().map(({ alias, label }) => ({ alpha3: alias, label }));
    formattedOptions.unshift({
      label: 'All Countries',
      alpha3: '',
    });

    return (
      <CompanySearchWidget
        countries={formattedOptions}
        title=""
        selectedCompanyIds={selectedCompany ? [selectedCompany?.id || ''] : ['']}
        onToggleCompanyId={handleToggleCompanyId}
      />
    );
  };

  return (
    <StyledDialog
      fullWidth
      maxWidth={'md'}
      open={open}
      onClose={handleClose}
      className={classes.root}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Box boxShadow={2}>
        <DialogTitle>
          {label}
        </DialogTitle>
      </Box>
      <DialogContent className={classes.dialogContent}>
        {renderCardContent()}
      </DialogContent>
      <Box boxShadow={2}>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={handleClose}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            autoFocus
            onClick={() => handleFinishSelect()}
          >
            Done
          </Button>
        </DialogActions>

      </Box>
    </StyledDialog>
  );
}

export default SearchCompanyDialog;
